export default {
  "ErrorScreen": "_ErrorScreen_1wvpj_1",
  "ErrorImage": "_ErrorImage_1wvpj_13",
  "ErrorCode": "_ErrorCode_1wvpj_17",
  "ErrorMessage": "_ErrorMessage_1wvpj_23"
};import "ni:sha-256;PN2Mb46V_m0QLMMOXqSpg04t44E6n1XT-ygROz_aqM8";